import React from 'react';
import ExternalLink from '../external-link';
const ThirdBulletContent = ({ partnerSignup }) => {
    const isProductName = (partnerSignup === null || partnerSignup === void 0 ? void 0 : partnerSignup.name) || null;
    switch (isProductName) {
        case 'QuickBooks Desktop':
        case 'QuickBooks Online':
            return React.createElement("span", null,
                'Annual plans start at $52.50 ',
                React.createElement(ExternalLink, { href: 'https://www.avalara.com/simplify/en/quickbooks-desktop-free-trial.html#pricing', alwaysOpenInNewTab: true }, "Learn more."));
        default:
            return React.createElement(ExternalLink, { href: 'https://youtu.be/RjAY9xsWidI', alwaysOpenInNewTab: true }, "Learn what Avalara can do for you");
    }
};
export default ThirdBulletContent;
